import externalApi from "../helpers/externalAPIs";

class CampaignService {
  async getAllCampaigns(queryParams = "") {
    try {
      const response = await externalApi.get(`/campaigns/fetch-campaigns-list${queryParams}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching campaigns:", error);
      throw error;
    }
  }

  async createCampaign(data) {
    try {
      const response = await externalApi.post(`/campaigns/add-basic-campaign`, data);
      return response.data;
    } catch (error) {
      console.error("Error creating campaign:", error);
      throw error;
    }
  }

  async getCampaignDetails(campaignId, facilityId = "") {
    try {
      const response = await externalApi.get(`/campaigns/get-campaign-details?campaignId=${campaignId}&facility_id=${facilityId}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching campaign details:", error);
      throw error;
    }
  }

  async getReadSASToken() {
    try {
      const response = await externalApi.get(`/campaigns/read-sas-token`);
      return response.data.data.token;
    } catch (error) {
      console.error("Error fetching read SAS token:", error);
      throw error;
    }
  }

  async getCampaignPatientsStatus(ruleId) {
    try {
      const response = await externalApi.get(`/campaigns/get-campaign-patients-status?ruleId=${ruleId}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching campaign patients status:", error);
      throw error;
    }
  }

  async getCampaignsData(campaignId) {
    try {
      const response = await externalApi.get(`/campaigns/get-campaigns-data?campaignId=${campaignId}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching campaigns data:", error);
      throw error;
    }
  }
}

export default new CampaignService();
